import type { Result } from "@pdfking/errors"
import { ResultMap, Success } from "@pdfking/errors"

import type { MathError, QuantityError } from "#public"
import type { QuantitySpec } from "#public"

import { EvaluateMath } from "./EvaluateMath"
import { Quantize } from "./Quantize"
import { StringToMath } from "./StringToMath"

// Parse and evaluate a measure expression into its value vector. With a `spec`
// the result must be a unit quantity (`exp: 1`); without one it must be a bare
// number (`exp: 0`) — enforced by EvaluateMath's required exponent.
export const StringToQuantity = <T extends number>(
  input: string,
  spec?: QuantitySpec<T>,
  length?: number
): Result<T[], QuantityError | MathError> =>
  ResultMap(StringToMath(input, spec, length), node => {
    const exp = spec ? 1 : 0 // a spec wants a unit (exp 1), else a bare number
    return ResultMap(
      EvaluateMath(node, { min: exp, max: exp }),
      // magnitudes are in base units, quantized to the spec's precision;
      // re-brand to the spec's quantity type.
      ({ vars: values }) =>
        Success((spec ? values.map(v => Quantize(v as T, spec)) : values) as T[])
    )
  })
